import { type ChoiceListPairs } from '@Utils/choiceListFilesUtils';
import { RECORD_TYPE } from '@Utils/choiceListMapping';
import { useGlobalization } from '@Translations';
import { type SystemTypeId } from '@innovyze/lib_asset_schema';

interface UseRecordTypeOptionsArgs {
	systemType?: SystemTypeId;
}

/**
 * Returns record type options for rule configuration, including INSPECTION and CONDITION.
 * Options are filtered by system type (e.g. Sanitary Sewer shows all types).
 */
export function useRecordTypeOptions({
	systemType,
}: UseRecordTypeOptionsArgs): {
	recordTypeOptionsFlagged: ChoiceListPairs[];
} {
	const { t } = useGlobalization();

	const result: ChoiceListPairs[] = [
		{ label: t('Asset attributes'), value: RECORD_TYPE.ASSET_ATTRIBUTES },
		{ label: t('Condition'), value: RECORD_TYPE.CONDITION },
		{ label: t('Inspection'), value: RECORD_TYPE.INSPECTION },
		{ label: t('Risk'), value: RECORD_TYPE.RISK },
		{ label: t('Custom Table'), value: RECORD_TYPE.USER_DEFINED_FIELDS },
		{ label: t('Task'), value: RECORD_TYPE.TASK },
		{ label: t('Event'), value: RECORD_TYPE.EVENT },
	];

	const recordTypeOptionsFlagged = result.filter(
		record =>
			systemType?.externalId === 'Sanitary Sewer' ||
			record.value === RECORD_TYPE.ASSET_ATTRIBUTES ||
			record.value === RECORD_TYPE.RISK ||
			record.value === RECORD_TYPE.USER_DEFINED_FIELDS ||
			record.value === RECORD_TYPE.TASK ||
			record.value === RECORD_TYPE.EVENT,
	);

	return {
		recordTypeOptionsFlagged,
	};
}
